export class Smsbitacora {
    TipoSMS:number;
    Id_MensajePredefinido?:number;
    MensajeLibre?:string;
    numeroCel:string;
    ID_beneficiario?:number;
    ID_Titular?:number;
    ID_grupo?:number;
    Id_UsuarioQenviaSMS:number;
    Area:number;
    Dependencia:number;
    Estado?:number;
    Numfactura?:number;
    NumCSC?:number;
}

